import { Menu as MuiMenu } from '@mui/material';
import { useTheme } from './hooks';
import type { MenuOwnerState, MenuProps as MuiMenuProps } from '@mui/material/Menu';
import type { SxProps, Theme } from '@mui/material/styles';

export type MenuProps = MuiMenuProps;

type MenuPaperSlotProps = NonNullable<MenuProps['slotProps']>['paper'];

export const Menu = ({ slotProps, ...rest }: MenuProps): JSX.Element => {
  const theme = useTheme();
  const basePaperSx: SxProps<Theme> = {
    backgroundColor: theme.app.colors.surface,
    backgroundImage: 'none',
    border: `1px solid ${theme.app.colors.border}`,
    boxShadow: 'none',
    '--Paper-overlay': 'none',
    '--Paper-shadow': 'none',
    '& .MuiMenuItem-root': {
      fontSize: theme.typography.subtitle1.fontSize,
      lineHeight: theme.typography.subtitle1.lineHeight,
      fontWeight: theme.typography.subtitle1.fontWeight,
    },
    '& .MuiMenuItem-root .MuiTypography-root, & .MuiMenuItem-root .MuiListItemText-primary': {
      fontSize: theme.typography.subtitle1.fontSize,
      lineHeight: theme.typography.subtitle1.lineHeight,
      fontWeight: theme.typography.subtitle1.fontWeight,
    },
  };

  const slotPaper = slotProps?.paper;
  const buildPaperProps = (ownerState: MenuOwnerState): MenuPaperSlotProps => {
    const resolved = typeof slotPaper === 'function' ? slotPaper(ownerState) : slotPaper;
    const resolvedSx = resolved?.sx;
    const mergedSx = resolvedSx ? [basePaperSx, resolvedSx] : basePaperSx;
    return {
      square: true,
      ...(resolved ?? {}),
      sx: mergedSx,
    } as MenuPaperSlotProps;
  };

  return (
    <MuiMenu
      {...rest}
      slotProps={{
        ...slotProps,
        paper: buildPaperProps,
      }}
    />
  );
};
